import { Component, Input } from "@angular/core";

@Component({
    selector: "app-base-preview",
    templateUrl: "./base-preview.component.html",
})
export class BasePreviewComponent {
    @Input() values: any[];
}
